export const en = {
  translation: {
    Login: "Login",
    "Create Account": "Create Account",
    Email: "Email",
    "Your email": "Your email",
    Password: "Password",
    "Your password": "Your password",
    "Forgot your password?": "Forgot your password?",
    "By continuing, you agree with the Privacy Policy and the Terms of Use. The site uses cookies as explained in the Privacy Policy.":
      "By continuing, you agree with the Privacy Policy and the Terms of Use. The site uses cookies as explained in the Privacy Policy.",
    Back: "Back",
    CreateAccountHeaderLabel: "{value}",
    Customer: "Πελάτης",
    Alias: "Alias",
    "Address Name": "Address Name",
    "Contact Name": "Contact Name",
    Country: "Country",
    "Upgrade your plan": "Upgrade your plan",
    "FORGOT YOUR PASSWORD": "FORGOT YOUR PASSWORD ?",
    "We will send you an email to reset your password.":
      "We will send you an email to reset your password.",
    "Email Address": "Email Address",
    "SEND ME THE EMAIL": "SEND ME THE EMAIL",
    "Back to login page": "Back to login page",
    "Instructions to reset your password have been sent to ":
      "Instructions to reset your password have been sent to ",
    " email.": " email.",
    "PASSWORD RESET": "PASSWORD RESET",
    "User with email ": "User with email ",
    "not found.": " not found.",
    "Please enter your new password.": "Please enter your new password.",
    "Please type password based on requirements":
      "Please type password based on requirements",
    "Please retype your password.": "Please retype your password.",
    "Your passwords do not match.": "Your passwords do not match.",
    "You asked to change your password": "You asked to change your password",
    "type the new password": "type the new password",
    "retype the new password": "retype the new password",
    "Password should contain": "Password should contain",
    "At least 8 characters": "At least 8 characters",
    "At least one upper case letter": "At least one upper case letter",
    "At least one lower case letter": "At least one lower case letter",
    "At least one digit": "At least one digit",
    "At least one special character (Ex. !@#$%)":
      "At least one special character (Ex. !@#$%)",
    LOGIN: "LOGIN",
    "User not found.": "User not found.",
    "User not authenticated":
      "The username / password you entered does not exist",
    "CHANGE PLAN": "CHANGE PLAN",
    FileDownloadError: "Download failed. Please contact support.",
    UpdateBookError: "Book update failed with error: ",
    "An error has occurred": "An error has occurred",
    Refresh: "Refresh",
  },
};
